import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';
import { NotFoundComponent } from './not-found/not-found.component';

import { BoardComponent } from './board/board.component';
import { PostitComponent } from './postit/postit.component';

import { ConnectComponent } from './connect/connect.component';

import { CreateBoardComponent } from './create-board/create-board.component';
import { CreateBoardSpacesComponent } from './create-board-spaces/create-board-spaces.component';

import { AuthGuard } from './guards/auth.guard';

const appRoutes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        data: { state: 'home' },
        component: CreateBoardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'board/nouveau/:board_id',
        pathMatch: 'full',
        data: { state: 'board_new' },
        component: BoardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'board/:id',
        pathMatch: 'full',
        data: { state: 'board' },
        component: BoardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'connect/:token',
        pathMatch: 'full',
        data: { state: 'connect' },
        component: ConnectComponent
      },
      {
        path: 'create-board',
        pathMatch: 'full',
        data: { state: 'board_create' },
        component: CreateBoardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit-board-spaces/:id',
        pathMatch: 'full',
        data: { state: 'edit_board_spaces' },
        component: CreateBoardSpacesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'create-board-spaces',
        pathMatch: 'full',
        data: { state: 'create_board_spaces' },
        component: CreateBoardSpacesComponent,
        canActivate: [AuthGuard],
      },
    ]
  },
  {
    path: 'postit/:uuid',
    pathMatch: 'full',
    data: { state: 'board' },
    component: PostitComponent,
    // canActivate: [AuthGuard],
  },
  {
    path: 'full/:project_board_uuid',
    pathMatch: 'full',
    data: { state: 'board' },
    component: BoardComponent,
    // canActivate: [AuthGuard],
  },
  { path: '**', component: NotFoundComponent }
];

export const Routing = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/app.routes.ts